export const resetTimeOnIdle = (setTime) => {
    const resetTimer = () => {
      setTime(0);
    };
    document.onmousemove = resetTimer;
    document.onmousedown = resetTimer;
    document.onkeypress = resetTimer;
    document.onscroll = resetTimer;
  };